import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';
import { useAuth } from '../AuthContext';
import 'react-quill/dist/quill.snow.css'; // Per formattazione HTML

const Guide = () => {
  const { user } = useAuth();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGuide = async () => {
      try {
        // Determina il tipo in base al ruolo dell'utente
        const type = user.role === 'business' ? 'business' : 'user';
        const res = await axios.get(`/api/guide/${type}`);
        setContent(res.data.content || '<p>Nessuna guida disponibile al momento.</p>');
      } catch (err) {
        console.error('Errore nel caricamento della guida:', err);
        setContent('<p>Errore nel caricamento della guida.</p>');
      } finally {
        setLoading(false);
      }
    };

    fetchGuide();
  }, [user.role]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  // Funzione per processare il contenuto HTML e aggiungere attributi ai video
  const processedContent = content.replace(/<video[^>]*src="([^"]*)"[^>]*>/g, 
    '<video src="$1" autoplay muted loop playsinline style="display:block;margin:1rem 0;max-width:100%;height:auto;"></video>'
  );

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        {user.role === 'business' ? 'Guida Aziende' : 'Guida Alunni'}
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Box
          className="ql-editor"
          dangerouslySetInnerHTML={{ __html: processedContent }}
          sx={{
            fontFamily: '"Titillium Web", "Roboto", "Helvetica", "Arial", sans-serif !important',
            '& *': { 
              fontFamily: '"Titillium Web", "Roboto", "Helvetica", "Arial", sans-serif !important'
            },
            '& img': { maxWidth: '100%', height: 'auto' },
            '& video': { 
              maxWidth: '100%', 
              height: 'auto',
              display: 'block',
              margin: '1rem 0'
            },
            '& a': { color: 'primary.main' }
          }}
        />
      </Paper>
    </Box>
  );
};

export default Guide;
